import axios from 'axios';
import messages from './en';
import localesApi from './../store/api/locales';
import { createI18n } from "vue-i18n";

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  globalInjection: true,
  messages: {
    en: messages,
  },
})

const loadedLanguages = ['en'];

function setI18nLanguage(lang) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = lang
  } else {
    i18n.global.locale.value = lang
  }

  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  return localesApi.getLocale(lang).then(
    (mess) => {
      i18n.global.setLocaleMessage(lang, mess);
      loadedLanguages.push(lang);
      return setI18nLanguage(lang);
    },
  ).catch((err) => {
    console.log(err);
  });
}

export default i18n;
